import Vue from 'vue'
import router from './index'
import store from '../store/index'
import '../config/toasted'

import { Ability } from '@casl/ability'
export const ability = new Ability()

router.beforeEach((to, from, next) => {
  
  const currentUser = store.state.currentUser
  const abilities = ability.update(store.state.rules)
  // console.log('store rules')
  // console.log(store.state.rules)
  // console.log('rules loaded')
  // console.log(abilities)
    
  const canNavigate = to.matched.some(route => {
    return abilities.can(route.meta.action || 'read', route.meta.resource)
  })

  if (currentUser && to.meta.requireAuthentication && canNavigate) {
    return next()
  }
  
  if (currentUser && to.meta.requireAuthentication && !canNavigate) {
    Vue.toasted.global.defaultError({ msg: "You are not able to access this resource."})
    return next(from)
  }

  if (!currentUser && to.meta.requireAuthentication) {
    Vue.toasted.global.defaultError({ msg: "You need to login before navigate to this route." })
    router.push({name: 'login'})
  }

  else {
    return next()
  }
})